import { render, staticRenderFns } from "./UserLegacy.vue?vue&type=template&id=0a7b4a1a&scoped=true&"
import script from "./UserLegacy.vue?vue&type=script&lang=ts&"
export * from "./UserLegacy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7b4a1a",
  null
  
)

export default component.exports